// const productLimits = {
//   'super-fuel': 3, 
// };


// function checkCartLimits() {
//   fetch('/cart.js')
//     .then((res) => res.json())
//     .then((cart) => {
//       const productTotals = {};

//       cart.items.forEach((item) => {
//         productTotals[item.handle] = (productTotals[item.handle] || 0) + item.quantity;
//       });

//       cart.items.forEach((item) => {
//         const handle = item.handle;
//         const limit = productLimits[handle];
//         alert(limit);
//         if (limit && productTotals[handle] > limit) {
          
          
//           const excess = productTotals[handle] - limit;
//           const newQty = item.quantity - excess > 0 ? item.quantity - excess : 0;

//           fetch('/cart/change.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: item.key, quantity: newQty }),
//           }).then(() => {
       
//             location.reload();
//           });
//         }
//       });
//     });
// }
const productLimits = {
  'super-fuel': 10,
};

function checkCartLimits() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      let total = 0;

      // Count all Super Fuel variants
      cart.items.forEach((item) => {
        if (item.handle.includes('super-fuel')) {
          total += item.quantity;
        }
      });

      const limit = productLimits['super-fuel'];
      if (total <= limit) return;

      let excess = total - limit;
var msg = $("#maxLimitMsg");

    msg.stop(true, true).fadeIn(300); 
    msg.css("animation", "none");
    msg[0].offsetHeight; 
    msg.css("animation", "");

    setTimeout(function() {
      msg.fadeOut(300);
    }, 3000);
      // Loop from newest → oldest
      for (let i = cart.items.length - 1; i >= 0 && excess > 0; i--) {
        const item = cart.items[i];

        if (item.handle.includes('super-fuel')) {
          const removeQty = Math.min(item.quantity, excess);
          const newQty = item.quantity - removeQty;

          excess -= removeQty;

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: newQty,
            }),
          }).then(() => {
            if (excess <= 0) {
             
              $("cart-drawer").load(location.href + " cart-drawer>*", "");
          $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*", "");
            }
          });
        }
      }
    });
}

document.addEventListener('change', function (event) {
  if (event.target.matches('input[name^="updates"]')) {
  setTimeout(() => {
    
    checkCartLimits();
  }, 1500);
  }
});

document.addEventListener('click', function (event) {
  const button = event.target.closest('form[action*="/cart/add"], button[name="add"], .add-to-cart');
  if (!button) return;

  setTimeout(() => {
    checkCartLimits();
  }, 500);
});

document.addEventListener('cart:updated', () => {
  
  setTimeout(() => {
    checkCartLimits();
  }, 1000);
});
function drawerfunction() {
  $("#CartDrawer").addClass("loading-cart");

  // Mark active gift choices
  $(".all-gifts-list .svg-with-id").each(function () {
    if ($(this).find(".checkmark-icon").css("opacity") == "0") {
      $(this).removeClass("active-value-js");
    } else {
      $(this).addClass("active-value-js");
    }
  });

  var checklength = $(".active-value-js").length;

  // Helper functions
  function addProduct(productId) {
   
    if (!$(".free-gift.product-id-" + productId).length) {
     console.log("Product ID: " + productId);
      $.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType: "json",
        async: false,
        data: { quantity: 1, id: productId, properties: { 'Product': 'Free Gift' } }
      });
    }
  }

function removeProduct(productId) {
  return new Promise(function (resolve) {
    var item = $('.cart-item.free-gift[data-product-index="' + productId + '"]');
    if (item.length) {
      const lineItemKey = item.data('line-item-key');
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify({ id: lineItemKey, quantity: 0 }),
        contentType: 'application/json',
        dataType: 'json',
        success: function () {
          console.log("Removed product ID: " + productId);
          $("cart-drawer").load(location.href + " cart-drawer>*", "");
          $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*", "");
          resolve();
          if ($("cart-drawer .cart-drawer .cart-item").length === 0) {
      $("cart-drawer").addClass("is-empty");
    }
        },
        error: function () {
          resolve(); // still resolve to continue the queue
        }
      });
    } else {
      resolve();
    }
    
  });
  
}

  // Get gift product IDs conditionally
  const product1 = $(".product-1-gift").length ? parseInt($(".product-1-gift").attr("data-gift")) : null;
  const product2 = $(".product-2-gift").length ? parseInt($(".product-2-gift").attr("data-gift")) : null;
  const product3 = $(".product-3-gift").length ? parseInt($(".product-3-gift").attr("data-gift")) : null;
  // Process based on selection count
  
if (checklength === 1) {
 
  // Only free shipping, no gifts
  if (product3) setTimeout(() => removeProduct(product3), 0);
  if (product2) setTimeout(() => removeProduct(product2), 1500);
  if (product1) setTimeout(() => removeProduct(product1), 3400);
  

} else if (checklength === 2) {
  
  if (product1) addProduct(product1);
  if (product3) setTimeout(() => removeProduct(product3), 0);
  if (product2) setTimeout(() => removeProduct(product2), 1500);
  

} else if (checklength === 3) {
 
  if (product1) addProduct(product1);
  if (product2) addProduct(product2);
 if (product3) setTimeout(() => removeProduct(product3), 0);

} else if (checklength === 4) {
  
  // if (product1) addProduct(product1);
  // if (product2) addProduct(product2);
  // if (product3) addProduct(product3);

} else {
  
  // Default: remove all
  if (product3) setTimeout(() => removeProduct(product3), 0);
  if (product2) setTimeout(() => removeProduct(product2), 1500);
  if (product1) setTimeout(() => removeProduct(product1), 3400);
}
setTimeout(function () {
  var removeerrprod = $('.cart-item.free-gift.remove-final-item');
    if (removeerrprod.length) {
    
const lineItemKeynew = removeerrprod.data('line-item-key');
      $.ajax({
        url: "/cart/change.js",
        type: "post",
        data: JSON.stringify({ id: lineItemKeynew, quantity: 0 }),
        contentType: 'application/json',
        success: function () {
          
            $("cart-drawer").load(location.href + " cart-drawer>*", "");
          $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*", "");
          drawerfunction();
          
        }
      });
    }
},1000);
setTimeout(function () {
  
  var removeerrprod = $('.cart-item.free-gift.remove-final-item');
    if (removeerrprod.length) {
     
const lineItemKeynew = removeerrprod.data('line-item-key');
      $.ajax({
        url: "/cart/change.js",
        type: "post",
        data: JSON.stringify({ id: lineItemKeynew, quantity: 0 }),
        contentType: 'application/json',
        success: function () {
          
            $("cart-drawer").load(location.href + " cart-drawer>*", "");
          $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*", "");
          drawerfunction();
          
        }
      });
    }
},3700);
  // Final clean-up
  setTimeout(function () {
    
    $("#CartDrawer").removeClass("loading-cart");
    if ($("cart-drawer .cart-drawer .cart-item").length === 0) {
      $("cart-drawer").addClass("is-empty");
    }
    if (window._GUARANTEE) _GUARANTEE.WriteKickers();
  }, 3700);
}

drawerfunction();

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedOnChange.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }
  onCartUpdate() {    
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
// setTimeout(function(){
//   drawerfunction();
  
// },200);
    setTimeout(function(){
  drawerfunction();
  
},300);

// setTimeout(function(){
//       $("cart-drawer").load(location.href + " cart-drawer>*","");
//   $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
//      },2500);  
  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];   
  }
  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
   

   //  setTimeout(function(){
   //  drawerfunction();
   // },200);
     setTimeout(function(){
  drawerfunction();
  
},300);
// setTimeout(function(){      
//          $("cart-drawer").load(location.href + " cart-drawer>*","");
//   $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
  
//      },2500);
 }
}
customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

